import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import RiskIndicationDefinition from '../../../../constants/RiskIndicationDefinition';

import style from './style/footerbar.scss';

const FooterBar = ({ data: { title, score, evaluation, translations }, classes }) => {
    let scoreLevel = '';
    let color = '';

    switch (score) {
        case RiskIndicationDefinition.LOW:
            color = style.green;
            scoreLevel = translations.report_evaluation_low;
            break;

        case RiskIndicationDefinition.MIDDLE:
            color = style.orange;
            scoreLevel = translations.report_evaluation_medium;
            break;

        case RiskIndicationDefinition.HIGH:
            color = style.red;
            scoreLevel = translations.report_evaluation_high;
            break;

        default:
            break;
    }

    if (!score || !Object.values(RiskIndicationDefinition).includes(score)) {
        return null;
    }

    return (<div className={ `${style.footerBar} ${color} ${classes && classes.root ? classes.root : ''}` }>
        <h3>{ title }</h3>
        <div className={ `${style.footerBar__description} ${classes && classes.description ? classes.description : ''}` }>
            <figure>
                <FontAwesomeIcon icon={ 'check' } />
            </figure>
            <div>
                <h4>{ scoreLevel }</h4>
                <p>{ evaluation }</p>
            </div>
        </div>
    </div>);
};

export default FooterBar;

FooterBar.propTypes = {
    data: PropTypes.shape({
        title: PropTypes.string,
        score: PropTypes.number.isRequired,
        evaluation: PropTypes.string,
        translations: PropTypes.object.isRequired
    }),
    classes: PropTypes.shape({
        root: PropTypes.string,
        description: PropTypes.string
    })
};
